export const config = {
  rowSelection: false,
  fieldControl: false,
  columns: [
    {title: '分类名称', dataIndex: 'name', width: 200,  ellipsis: true},
    {title: '最后更新人', dataIndex: 'modifiedByName', width: 200, ellipsis: true},
    {title: '最后更新时间', dataIndex: 'lastUpdatedTime', width: 200, itemType: 'dateTime'},
    {title: '操作', dataIndex: 'action', fixed: 'right', width: 180, render: 'actionRender'},
  ],
  footer: [
    {label: '新增', type: 'primary', events: ['onClick:onAdd']}
  ]
}
